import metadata from "$public/metadata.json";
import { capitalize } from "$utils/capitalize";
export const challengeStatusChoices = metadata.Challenge.status.type.map((id) => ({
    id,
    name: capitalize(id).replaceAll("_", " ")
}));
